// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"EmptyLayout--next-sr-only--2JfmlTK","container":"EmptyLayout--container--11XSiVk"};